import React from 'react'
import UserList from '../Pages/UserList'

const index = () => {
  return <UserList />
}

export default index
